import React from "react";
import axios from "axios";
import { useState } from "react";
import location from './location.png'
import mail from './mail.png'
import phonecall from './phonecall.png'
import './Footer.css'


export default function Contact() {


  const formId = "0t2J8eB0x";
  const formUrl = `https://submit-form.com/${formId}`

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [message, setMessage] = useState("");
  const [result, setResult] = useState("")

  // const [values, setValues] = useState(initialFormValues);
  
  const submitForm = async (e) => {
    e.preventDefault();
    await postSubmission();
    setResult("Music to Our Ears, We'll Be in Touch!");
    setName("");
    setCompany("");
    setEmail("");
    setMessage("");
  };

  
  const postSubmission = async () => {
    const formInfo = {
      name: name,
      email:email,
      message:message,
    };
  
  

    try {
      const res = await axios.post(formUrl, formInfo);
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };



  return (
    <div className="footer">
      <div className="firstcontactbox-container">

        <div className="contact-header">
        <h1>Let's Talk About The Future</h1>
        </div>
        
        <div className="secondcontact-container">
        <div className="contactinfo-container">
          <div><img className='location-icon' src={location} width={20} height={20} alt='Location icon'></img>Serving the DMV Area</div>
          <div><img className='phone-icon' src={phonecall} width={20} height={20} alt='Phone icon'></img><a href="tel:443-252-3005">443-252-3005</a></div>
          <div><img className='email-icon ' src={mail} width={20} height={20} alt='Email icon'></img>
            <a href="mailto:help-me@symphony-it.com">help-me@symphony-it.com</a></div>
        </div>


      <div className="contactform-container">
      <div className="title-box">
      <h1>CONTACT US</h1>
      </div>
        <div className="form-container">
          <form id="form" onSubmit={submitForm} className="form-text" aria-label="Contact form">
          <div className="form-item">
          <input type="text" id="sender" name="sender" onChange={(e) => { setName(e.target.value) }} value={name} aria-label="Name" required/>
          <label htmlFor="sender">Name</label>
        </div>
        <div className="form-item">
          <input type="email" id="email" name="email" onChange={(e) => { setEmail(e.target.value) }} value={email} aria-label="Email" required/>
          <label htmlFor="email">Email</label>
              </div>
              <div className="form-item">
          <input type="text" id="company" name="company" onChange={(e) => { setCompany(e.target.value) }} value={company} aria-label="Company" required/>
          <label htmlFor="company">Company</label>
        </div>
        <div className="form-item">
              <textarea className="" id="message" name="message" onChange={(e) => { setMessage(e.target.value) }} value={message} aria-label="Message" required></textarea>
          <label htmlFor="message">Message</label>
        </div>
        <button type="submit" className="submit-btn" aria-label="Send message">SEND</button>
         </form>
        </div>
        <div role="status" aria-live="polite"> <h4>{result}</h4></div>
        </div>
        </div>
        
      </div>
      </div>
  )
}
